import { render, staticRenderFns } from "./FbaBarcode.vue?vue&type=template&id=18d411c6&scoped=true&"
import script from "./FbaBarcode.vue?vue&type=script&lang=js&"
export * from "./FbaBarcode.vue?vue&type=script&lang=js&"
import style0 from "./FbaBarcode.vue?vue&type=style&index=0&id=18d411c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d411c6",
  null
  
)

export default component.exports